module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en-US":{"properties":"Properties","account":"Account","exchangeRate":"Exchange rate"},"es-MX":{"properties":"Propiedades","account":"Cuenta","exchangeRate":"Tipo de cambio"}}')
  delete Component.options._Ctor
}
